import React, { useState, useEffect } from 'react';
import clinicService from '../../../services/clinic.service'
import { useEyeconxStore } from '../../../store/eyeconxStore'
import Loading from '../../common/Loading'
import ModernTabs from '../../common/Tabs/ModernTabs'
import ReputationLinkTab from "./tabcards/ReputationLinkTab";
import CommentsTab from "./tabcards/CommentsTab";
import FeedbackTab from "./tabcards/FeedbackTab";
import OverviewTab from "./tabcards/OverviewTab";
import SubHeader from "../../layout/components/SubHeader";
const Reputation = () => {
    const [loading, setLoading] = useState(true);
    const [shortCode, setShortCode] = useState(null);
    const [reputationLinks, setReputationLinks] = useState([]);
    const [patientComments, setPatientComments] = useState([]);
    const [patientFeedbacks, setPatientFeedbacks] = useState([]);
    const [activeTab, setActiveTab] = useState('overview');
    const clinicId = useEyeconxStore((state) => state.user.clinicId);

    useEffect(() => {
        fetchReputationData();
    }, []);

    const fetchReputationData = async () => {
        try {
            setLoading(true);
            const [shortCodeRes, linksRes, commentsRes, feedbacksRes] = await Promise.all([
                clinicService.getReputationShortCode(clinicId),
                clinicService.getReputationLink(clinicId),
                clinicService.PatientComments(clinicId),
                clinicService.PatientFeedbacks(clinicId)
            ]);

            setShortCode(shortCodeRes.data);
            setReputationLinks(linksRes.data);
            setPatientComments(commentsRes.data ||{ content: [], totalElements: 0, totalPages: 0 });
            setPatientFeedbacks(feedbacksRes.data || { content: [], totalElements: 0, totalPages: 0 });

        } catch (error) {
            console.error('Error fetching reputation data:', error);
        } finally {
            setLoading(false);
        }
    };

    const getStatusBadge = (status) => {
        const statusConfig = {
            SENT: { class: 'bg-success', icon: 'bi-check-circle', text: 'Sent' },
            PENDING: { class: 'bg-warning text-dark', icon: 'bi-clock', text: 'Pending' },
            ERROR: { class: 'bg-danger', icon: 'bi-exclamation-triangle', text: 'Error' }
        };
        const config = statusConfig[status] || statusConfig.PENDING;
        return (
            <span className={`badge ${config.class}`}>
                <i className={`bi ${config.icon} me-1`}></i>
                {config.text}
            </span>
        );
    };

    const getFeedbackIcon = (feedback) => {
        const feedbackIcons = {
            0: { icon: 'bi-emoji-angry-fill', class: 'text-danger', label: 'Negative' },
            1: { icon: 'bi-emoji-neutral-fill', class: 'text-warning', label: 'Neutral' },
            2: { icon: 'bi-emoji-smile-fill', class: 'text-success', label: 'Positive' }
        };
        const config = feedbackIcons[feedback] || feedbackIcons[1];
        return (
            <div className="d-flex align-items-center">
                <i className={`bi ${config.icon} ${config.class} fs-4 me-2`}></i>
                <span className="small text-muted">{config.label}</span>
            </div>
        );
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const getLinkIcon = (linkType) => {
        const icons = {
            FACEBOOK: 'bi-facebook text-primary',
            WEBSITE: 'bi-globe text-info',
            GOOGLE: 'bi-google text-success',
            YELP: 'bi-star-fill text-warning',
            INSTAGRAM: 'bi-instagram text-danger'
        };
        return icons[linkType] || 'bi-link-45deg';
    };
    const fetchPatientComments = async (page = 0, size = 10) => {
        try {
            const response = await clinicService.PatientComments(clinicId, page, size);
            setPatientComments(response.data);
        } catch (error) {
            console.error('Error fetching patient comments:', error);
        }
    };

    const fetchPatientFeedbacks = async (page = 0, size = 10) => {
        try {
            const response = await clinicService.PatientFeedbacks(clinicId, page, size);
            setPatientFeedbacks(response.data);
        } catch (error) {
            console.error('Error fetching patient feedbacks:', error);
        }
    };

    if (loading) {
        return (
            <div className="text-center py-5">
                <Loading />
                <p className="text-muted mt-2">Loading reputation data...</p>
            </div>
        );
    }
    const TabContent = [
        {
            id:'overview',
            label:'Overview',
            icon:'bi-speedometer2',
            content:<OverviewTab shortCode={shortCode} reputationLinks={reputationLinks} patientComments={patientComments} patientFeedbacks={patientFeedbacks} formatDate={formatDate} getStatusBadge={getStatusBadge} getFeedbackIcon={getFeedbackIcon}/>
        },
        {
            id:'reputation-links',
            label:'Reputation Links',
            icon:'bi-link-45deg',
            content:<ReputationLinkTab reputationLinks={reputationLinks} getLinkIcon={getLinkIcon} formatDate={formatDate} />
        },
        {
            id:'comments',
            label:'Patient Comments',
            icon:'bi-chat-dots',
            content: <CommentsTab
                patientComments={patientComments}
                onPageChange={fetchPatientComments}
                getStatusBadge={getStatusBadge}
                formatDate={formatDate}
            />
        },
        {
            id:'feedbacks',
            label:'Patient Feedback',
            icon:'bi-emoji-smile',
            content: <FeedbackTab
                patientFeedbacks={patientFeedbacks}
                onPageChange={fetchPatientFeedbacks}
                getFeedbackIcon={getFeedbackIcon}
                formatDate={formatDate}
            />
        },
    ]
    return (
        <>
            <SubHeader title="Reputation Enhancement" description="Manage and monitor your clinic's online presence and patient feedback" />
            <ModernTabs orientation={'horizontal'} tabs={TabContent} className="mt-3" />

        </>
    );
};

export default Reputation;